export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
export const PHONE_REGEX = /^\+?[1-9]\d{7,14}$/;

export function validateEmail(value) {
  const v = (value || '').trim();
  if (!v) return 'Email is required';
  if (!EMAIL_REGEX.test(v)) return 'Enter a valid email address';
  return '';
}

export function validatePhone(value) {
  const v = (value || '').replace(/[\s\-()]/g, '');
  if (!v) return 'Phone number is required';
  if (!PHONE_REGEX.test(v)) return 'Enter a valid phone number (8–15 digits, optional +)';
  return '';
}

export function validateName(value) {
  const v = (value || '').trim();
  if (!v) return 'Full name is required';
  if (v.length < 2) return 'Name must be at least 2 characters';
  if (v.length > 60) return 'Name must be under 60 characters';
  if (!/^[\p{L}][\p{L}\s'.-]+$/u.test(v)) return 'Name contains invalid characters';
  return '';
}

export function validatePassword(value) {
  const v = value || '';
  if (!v) return 'Password is required';
  if (v.length < 8) return 'Password must be at least 8 characters';
  if (!/[A-Z]/.test(v)) return 'Password must contain an uppercase letter';
  if (!/[a-z]/.test(v)) return 'Password must contain a lowercase letter';
  if (!/[0-9]/.test(v)) return 'Password must contain a number';
  return '';
}

export function validateIdentifier(method, value) {
  return method === 'email' ? validateEmail(value) : validatePhone(value);
}

export function validateOtp(digits) {
  const code = (digits || []).join('');
  if (code.length !== 6) return 'Enter the 6-digit code';
  if (!/^\d{6}$/.test(code)) return 'OTP must be digits only';
  return '';
}

export function validateConsents({ termsConsent }) {
  const errors = {};
  if (!termsConsent) errors.termsConsent = 'You must accept the Terms and Privacy Policy';
  return errors;
}
